/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */


import { InspectorControls, MediaUpload, useBlockProps } from '@wordpress/block-editor';
// import { Panel, PanelBody, ToggleControl, __experimentalRadio as Radio, __experimentalRadioGroup as RadioGroup } from '@wordpress/components';
import { Button, Card, CardBody, CardMedia, ExternalLink, Panel, PanelBody, TabPanel, TextControl, ToggleControl, __experimentalBoxControl as BoxControl, __experimentalRadio as Radio, __experimentalRadioGroup as RadioGroup, __experimentalText as Text, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { doAction } from '@wordpress/hooks';
import { __ } from '@wordpress/i18n';
import React from 'react';
import { ReactComponent as BlockplayerConfiguration } from '../../assets/icons/blockplayer-configuration.svg';
import { ReactComponent as BlockplayerControls } from '../../assets/icons/blockplayer-controls.svg';
import { ReactComponent as BlockplayerFileUpload } from '../../assets/icons/blockplayer-file-upload.svg';
import { ReactComponent as BlockplayerImg } from '../../assets/icons/blockplayer-poster-img.svg';
import { ReactComponent as BlockplayerStyle } from '../../assets/icons/blockplayer-style.svg';
import { ReactComponent as BlockplayerTwitch } from '../../assets/icons/blockplayer-twitch.svg';
import { ReactComponent as BlockplayerUpload } from '../../assets/icons/blockplayer-upload.svg';
import { ReactComponent as BlockplayerVimeo } from '../../assets/icons/blockplayer-vimeo.svg';
import { ReactComponent as BlockplayerYT } from '../../assets/icons/blockplayer-yt.svg';
import BlockPlayer from './player';
// import { hot } from 'react-hot-loader'
// import screenfull from 'screenfull';
// import Duration from './Duration';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style/editor.sass';

//  

// import './video-render';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
    const { radius, devurl, downloadcontrols, fullscreencontrols, volumecontrols, mutecontrols, progresscontrols, forwardcontrols, rewindcontrols, restartcontrols, playcontrols, bigplayctr, pipcontrols, width, height, urltype, url, youtubeurl, vimeourl, poster, pip, playing, controls, light, volume, muted, played, loaded, duration, playbackRate, loop, styleinfo } = attributes
    const playingHandelar = (e) => {
        setAttributes(
            {
                playing: ! playing,
            }
        ) 
    }
    const devurlHandelar = (e) => {
        setAttributes(
            {
                devurl: ! devurl,
            }
        ) 
    }
    const muteHandelar = (e) => {
        setAttributes(
            {
                muted: ! muted,
            }
        ) 
    }
    const loopHandelar = (e) => {
        setAttributes(
            {
                loop: ! loop,
            }
        ) 
    }

    const urlTypeHandelar = (e) => {
        setAttributes(
            {
                urltype: e
            }
        ) 
    }

    const pipControlsHandelar = (e) => {
        setAttributes(
            {
                pipcontrols: !pipcontrols
            }
        ) 
    }
    const bigPlayControlsHandelar = (e) => {
        setAttributes(
            {
                bigplayctr: !bigplayctr
            }
        ) 
    }
    const playControlsHandelar = (e) => {
        setAttributes(
            {
                playcontrols: !playcontrols
            }
        ) 
    }
    const restartControlsHandelar = (e) => {
        setAttributes(
            {
                restartcontrols: !restartcontrols
            }
        ) 
    }
    const rewindControlsHandelar = (e) => {
        setAttributes(
            {
                rewindcontrols: !rewindcontrols
            }
        ) 
    }
    const forwardControlsHandelar = (e) => {
        setAttributes(
            {
                forwardcontrols: !forwardcontrols
            }
        ) 
    }
    const progressControlssHandelar = (e) => {
        setAttributes(
            {
                progresscontrols: !progresscontrols
            }
        ) 
    }
    const muteControlsHandelar = (e) => {
        setAttributes(
            {
                mutecontrols: !mutecontrols
            }
        ) 
    }
    const volumeControlsHandelar = (e) => {
        setAttributes(
            {
                volumecontrols: !volumecontrols
            }
        ) 
    }
    const fullScreenControlsHandelar = (e) => {
        setAttributes(
            {
                fullscreencontrols: !fullscreencontrols
            }
        ) 
    }
    const radiusHandelar = (e) => {
        setAttributes(
            {
                radius: e
            }
        ) 
    }
	return (
		<div { ...useBlockProps() }>
            <InspectorControls key="blockplayer-inspector-controls">
                {doAction('blockplayer-do-action', [attributes, setAttributes, useBlockProps])}
                <Panel className="blockplayer-content-panel-area">
                    <PanelBody
                        title={
                            (
                                <>
                                    <span className="blockplayer-panel-icon">
                                        <BlockplayerUpload
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                    <span className="blockplayer-panel-title">{ __( 'Blockplayer Content', 'blockplayer' ) }</span>
                                </>
                            )
                        }
                        initialOpen={ true }
                    >
                        {/* <Text className="blockplayer-content-title">Video upload/url option</Text> */}
                        <RadioGroup
                            label="upload-video"
                            onChange={
                                (e) => urlTypeHandelar(e)
                            }
                            checked={ urltype }
                        >
                            <Radio value="mp4">
                                <MediaUpload
                                    onSelect={ ( media ) => {
                                        setAttributes(
                                            {
                                                url: media.url
                                            }
                                        )
                                    } }
                                    allowedTypes={ [ 'video/mp4', 'video/m4v' ] }
                                    value={ url }
                                    render={ ( { open } ) => (
                                        <BlockplayerFileUpload
                                            onClick={ open }
                                            viewBox="0 0 24 24"
                                        />
                                    ) }
                                />
                            </Radio>
                            <Radio value="youtube">
                                <BlockplayerYT
                                    viewBox="0 0 24 24"
                                />
                            </Radio>
                            <Radio value="vimeo">
                                <BlockplayerVimeo
                                    viewBox="0 0 24 24"
                                />
                            </Radio>
                            <Radio value="twitch">
                                <BlockplayerTwitch
                                    viewBox="0 0 24 24"
                                />
                            </Radio>
                        </RadioGroup>
                        {
                            urltype == 'twitch' &&
                                <ExternalLink href="https://gutenplayer.com/blockplayer-pro/">
                                    <Button
                                        className="blockplayer-content-button"
                                        variant="primary"
                                        onClick={
                                            e => {
                                                // console 
                                            }
                                        }
                                    >
                                        Options Available on BlockPlayerPro
                                    </Button>
                                </ExternalLink>
                        }
                        {
                            urltype == 'youtube' &&
                            <>
                                <TextControl
                                    value={ youtubeurl }
                                    help={'provide a youtube id'}
                                    className="blockplayer-content-url-field"
                                    onChange={
                                        e => {
                                            setAttributes(
                                                {
                                                    youtubeurl: e
                                                }
                                            )
                                        }
                                    }
                                />
                                <Button
                                    className="blockplayer-content-button-none"
                                    variant="secondary"
                                    onClick={
                                        setAttributes(
                                            {
                                                url: `https://www.youtube.com/watch?v=${youtubeurl}`
                                            }
                                        )
                                    }
                                >
                                    Update Url
                                </Button>
                            </>
                        }
                        {
                            urltype == 'vimeo' &&
                            <>
                                <TextControl
                                    value={ vimeourl }
                                    help={'provide a vimeo id'}
                                    className="blockplayer-content-url-field"
                                    onChange={
                                        e => {
                                            setAttributes(
                                                {
                                                    vimeourl: e
                                                }
                                            )
                                        }
                                    }
                                />
                                <Button
                                    className="blockplayer-content-button-none"
                                    variant="secondary"
                                    onClick={
                                        setAttributes(
                                            {
                                                url: `https://vimeo.com/${vimeourl}`
                                            }
                                        )
                                    }
                                >
                                    Update Url
                                </Button>
                            </>
                        }
                    </PanelBody>
                </Panel>
                <Panel className="blockplayer-content-panel-area">
                    <PanelBody
                        title={
                            (
                                <>
                                    <span className="blockplayer-panel-icon">
                                        <BlockplayerImg
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                    <span className="blockplayer-panel-title">{ __( 'Blockplayer Poster', 'blockplayer' ) }</span>
                                </>
                            )
                        }
                        initialOpen={ false }
                    >
                        <Card  className="blockplayer-content-poster-area">
                            <CardBody>
                                <Text className="blockplayer-content-title">Video Poster Upload</Text>
                                <MediaUpload
                                    onSelect={ ( media ) => {
                                        setAttributes(
                                            {
                                                poster: media.url
                                            }
                                        )
                                    } }
                                    allowedTypes={ [ 'image' ] }
                                    value={ url }
                                    render={ ( { open } ) => (
                                        <button
                                            className='btn-icon-poster-upload'
                                            onClick={ open }
                                        >
                                            <BlockplayerFileUpload
                                                className="svg-icon-poster-upload"
                                                viewBox="0 0 24 24"
                                            />
                                        </button>
                                    ) }
                                />
                                {poster &&
                                    <CardMedia>
                                        <img src={poster} />
                                    </CardMedia>
                                }
                            </CardBody>
                        </Card>
                    </PanelBody>
                </Panel>
                <Panel className="blockplayer-configure-panel-area">
                    <PanelBody
                        title={
                            (
                                <>
                                    <span className="blockplayer-panel-icon">
                                        <BlockplayerConfiguration
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                    <span className="blockplayer-panel-title">{ __( 'Blockplayer Configure', 'blockplayer' ) }</span>
                                </>
                            )
                        }
                        initialOpen={ false }
                    >
                        <UnitControl
                            className="blockplayer-unitcontrol"
                            labelPosition={'edge'}
                            onChange={ e => setAttributes({ width: e }) }
                            value={ width }
                            size={ 'small' }
                            label={'player width'}
                        />
                        <UnitControl
                            labelPosition={'edge'}
                            className="blockplayer-unitcontrol"
                            onChange={ e => setAttributes({ height: e }) }
                            value={ height }
                            size={ 'small' }
                            label={'player height'}
                        />
                        <ToggleControl
                            className="re-loop-a"
                            label={__('Loop')}
                            help={
                                loop
                                    ? __('Loop on')
                                    : __('Loop off')
                            }
                            checked={ loop }
                            onChange={
                                (e) => loopHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="mute-unmute-a"
                            label={__('Mute')}
                            help={
                                muted
                                    ? __('Mute on')
                                    : __('Mute off')
                            }
                            checked={ muted }
                            onChange={
                                (e) => muteHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="re-playing-a"
                            label={__('Autoplay')}
                            help={
                                playing
                                    ? __('Autoplay on')
                                    : __('Autoplay off')
                            }
                            checked={ playing }
                            onChange={
                                (e) => playingHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="re-playing-a"
                            label={__('Show Developer Url')}
                            help={
                                devurl
                                    ? __('on')
                                    : __('off')
                            }
                            checked={ devurl }
                            onChange={
                                (e) => devurlHandelar(e)
                            }
                        />
                    </PanelBody>
                </Panel>
                <Panel className="blockplayer-controls-panel-area">
                    <PanelBody
                        title={
                            (
                                <>
                                    <span className="blockplayer-panel-icon">
                                        <BlockplayerControls
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                    <span className="blockplayer-panel-title">{ __( 'Blockplayer Controls', 'blockplayer' ) }</span>
                                </>
                            )
                        }
                        initialOpen={ false }
                    >
                        <ToggleControl
                            className="full-screen-controls"
                            label={__('FullScreen icon control')}
                            help={
                                fullscreencontrols
                                    ? __('Full Screen icon on')
                                    : __('Full Screen icon off')
                            }
                            checked={ fullscreencontrols }
                            onChange={
                                (e) => fullScreenControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="volume-controls"
                            label={__('Volume control')}
                            help={
                                volumecontrols
                                    ? __('Volume icon on')
                                    : __('Volume icon off')
                            }
                            checked={ volumecontrols }
                            onChange={
                                (e) => volumeControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="mute-controls"
                            label={__('Mute control')}
                            help={
                                mutecontrols
                                    ? __('Mute icon on')
                                    : __('Mute icon off')
                            }
                            checked={ mutecontrols }
                            onChange={
                                (e) => muteControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="progress-controls"
                            label={__('Progress control')}
                            help={
                                progresscontrols
                                    ? __('Progress bar on')
                                    : __('Progress bar off')
                            }
                            checked={ progresscontrols }
                            onChange={
                                (e) => progressControlssHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="forward-controls"
                            label={__('Forward control')}
                            help={
                                forwardcontrols
                                    ? __('Forward icon on')
                                    : __('Forward icon off')
                            }
                            checked={ forwardcontrols }
                            onChange={
                                (e) => forwardControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="rewind-controls"
                            label={__('Rewind control')}
                            help={
                                rewindcontrols
                                    ? __('Rewind icon on')
                                    : __('Rewind icon off')
                            }
                            checked={ rewindcontrols }
                            onChange={
                                (e) => rewindControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="restart-controls"
                            label={__('Restart control')}
                            help={
                                restartcontrols
                                    ? __('Restart icon on')
                                    : __('Restart icon off')
                            }
                            checked={ restartcontrols }
                            onChange={
                                (e) => restartControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="play-controls"
                            label={__('Play control')}
                            help={
                                playcontrols
                                    ? __('Play icon on')
                                    : __('Play icon off')
                            }
                            checked={ playcontrols }
                            onChange={
                                (e) => playControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="big-play-controls"
                            label={__('Big Play control')}
                            help={
                                bigplayctr
                                    ? __('Big Play icon on')
                                    : __('Big Play icon off')
                            }
                            checked={ bigplayctr }
                            onChange={
                                (e) => bigPlayControlsHandelar(e)
                            }
                        />
                        <ToggleControl
                            className="pip-controls"
                            label={__('PIP control')}
                            help={
                                pipcontrols
                                    ? __('PIP icon on')
                                    : __('PIP icon off')
                            }
                            checked={ pipcontrols }
                            onChange={
                                (e) => pipControlsHandelar(e)
                            }
                        />
                    </PanelBody>
                </Panel>
                
                <Panel className="blockplayer-style-panel-area">
                    <PanelBody
                        title={
                            (
                                <>
                                    <span className="blockplayer-panel-icon">
                                        <BlockplayerStyle
                                            viewBox="0 0 24 24"
                                        />
                                    </span>
                                    <span className="blockplayer-panel-title">{ __( 'Blockplayer Style', 'blockplayer' ) }</span>
                                </>
                            )
                        }
                        initialOpen={ false }
                    >
                        <TabPanel
                            className="blockplayer-tab-panel"
                            activeClass="active-tab"
                            onSelect={ (e)=> {
                                // console.log(e)
                            } }
                            tabs={ [
                                {
                                    name: 'blockplayer-style-panel-base',
                                    title: 'Base',
                                    className: 'blockplayer-style-panel-base',
                                },
                                {
                                    name: 'blockplayer-style-panel-color',
                                    title: 'Color',
                                    className: 'blockplayer-style-panel-color',
                                },
                            ] }
                        >
                            { ( tab ) => 
                                <>
                                    {
                                        tab.name == 'blockplayer-style-panel-base' && 
                                            <>
                                                <BoxControl
                                                    label={ 'Border radius' }
                                                    values={ radius }
                                                    onChange={
                                                        (e) => radiusHandelar(e)
                                                    }
                                                />
                                                
                                                <ExternalLink href="https://gutenplayer.com/blockplayer-pro/">
                                                    <Button
                                                        className="blockplayer-panel-button"
                                                        variant="primary"
                                                        onClick={
                                                            e => {
                                                                // console 
                                                            }
                                                        }
                                                    >
                                                        Options Available on BlockPlayerPro
                                                    </Button>
                                                </ExternalLink>
                                            </>
                                    }
                                    {
                                        tab.name == 'blockplayer-style-panel-color' && 
                                            <ExternalLink href="https://gutenplayer.com/blockplayer-pro/">
                                                <Button
                                                    className="blockplayer-panel-button"
                                                    variant="primary"
                                                    onClick={
                                                        e => {
                                                            // console 
                                                        }
                                                    }
                                                >
                                                    Options Available on BlockPlayerPro
                                                </Button>
                                            </ExternalLink>
                                    }
                                </>
                            }
                        </TabPanel>
                    </PanelBody>
                </Panel>
            </InspectorControls>
            <div className='blockplayer-main-area'>
                <BlockPlayer
                    attributes={attributes}
                />
            </div>
		</div>
	);
}
